export class ConfigDB {
    static data = {
      settings: {
        layout_type: 'ltr',
        layout_class: 'compact-wrapper',
        sidebar: {
          iconType: 'stroke',
        },
        sidebar_setting: 'default-sidebar',
      },
      color: {
        primary_color:'#8c2dbf',
        secondary_color: '#3632a3',
        mix_background_layout: 'dark-sidebar',
      }
    };
  }
  export default ConfigDB;